import { toPieItems } from '@/common/app/modules/media/shareOfVoice'
import { OverallShareItem } from '@/common/model/media/shareOfVoice'

import PieChart from '@/components/view/atoms/chart/PieChart'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import GeoChartCard from '@/components/container/modules/mediaGeo/common/GeoChartCard'

interface Props {
  overallShareChart: OverallShareItem[]
}

// ブランド別シェア・オブ・ボイスのドーナツグラフ（中央に合計シェアを表示）
const ShareOfVoiceShareChart = ({ overallShareChart }: Props) => {
  const items = toPieItems(overallShareChart)

  if (items.length === 0) {
    return (
      <GeoChartCard title='各ブランドの言及シェア率' height={80}>
        <Text size={12} color={TextColor.PLACEHOLDER}>
          シェアデータがありません。
        </Text>
      </GeoChartCard>
    )
  }

  return (
    <GeoChartCard title='各ブランドの言及シェア率'>
      <PieChart
        items={items}
        maxMainItems={items.length}
        centerLabel='合計シェア'
        tooltipTitle='シェア率'
      />
    </GeoChartCard>
  )
}

export default ShareOfVoiceShareChart
